import React from 'react';
import styles from './Header.scss';
import { Text, IconButton } from 'wix-style-react';
import { TranslationFunction } from 'react-i18next';
import { Help } from 'wix-ui-icons-common';

export interface HeaderProps {
  t: TranslationFunction;
  supportLink: string;
}

export const Header: React.FC<HeaderProps> = ({ t, supportLink }) => {
  return (
    <div className={styles.header}>
      <span className={styles.title}>
        <Text skin="standard" weight="bold" className={styles.text}>
          {t('TITLE')}
        </Text>
      </span>
      <IconButton
        as="a"
        href={supportLink}
        target="_blank"
        skin="transparent"
        className={styles.icon}
      >
        <Help />
      </IconButton>
    </div>
  );
};
